import messages from "../messages/messages.js";

export function Footer() {
    const lookingForLinks = [
        {
            url: messages["LOOKING_FOR.1.URL"],
            text: messages["LOOKING_FOR.1.TEXT"],
        },
        {
            url: messages["LOOKING_FOR.2.URL"],
            text: messages["LOOKING_FOR.2.TEXT"],
        },
    ].filter((link) => link.url && link.text);

    return (
        <footer className="border-t px-4 py-6 text-sm text-gray-400">
            <div className="container mx-auto flex flex-col-reverse md:flex-col md:flex-row justify-between gap-6 md:gap-4">

                <div className="flex flex-col md:justify-start gap-6 md:gap-4">
                    <div className="flex items-center gap-3">
                        <p className="mb-0 text-gray-400">Looking for something else?</p>
                        <div className="flex flex-wrap gap-2">
                            {lookingForLinks.map((link) => (
                                <a
                                    key={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="no-underline rounded-full border border-gray-700 px-3 text-gray-300 hover:border-gray-500 hover:text-white"
                                    href={link.url}
                                >
                                    {link.text}
                                </a>
                            ))}
                        </div>
                    </div>
                    <p className="text-gray-400 mb-0">© {new Date().getFullYear()} Copyright {messages["SITE.NAME"]}. All
                        rights reserved.</p>
                </div>

                <div className="flex flex-col md:justify-start gap-6 md:gap-4">


                    <div className="flex md:justify-end gap-6 md:gap-4 md:gap-10 gap-y-4 fs-4 flex-wrap">
                        {messages["DISCORD_URL"] !== "" &&
                            <a target="_blank" rel="noopener noreferrer" aria-label="Discord icon" href={messages.DISCORD_URL}>
                                <svg className="fill-gray-400 hover:fill-white" xmlns="http://www.w3.org/2000/svg"
                                     height="1.5em" viewBox="0 0 640 512">
                                    <path
                                        d="M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"></path>
                                </svg>
                            </a>
                        }
                        {messages["INSTAGRAM_URL"] !== "" &&
                            <a target="_blank" rel="noopener noreferrer" aria-label="Instagram icon" href={messages.INSTAGRAM_URL}>
                                <svg className="fill-gray-400 hover:fill-white" xmlns="http://www.w3.org/2000/svg"
                                     height="1.5em" viewBox="0 0 448 512">
                                    <path
                                        d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>
                                </svg>
                            </a>
                        }
                        {messages["X_URL"] !== "" &&
                            <a target="_blank" rel="noopener noreferrer" aria-label="X icon" href={messages.X_URL}>
                                <svg className="fill-gray-400 hover:fill-white" xmlns="http://www.w3.org/2000/svg"
                                     height="1.5em" viewBox="0 0 512 512">
                                    <path
                                        d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
                                </svg>
                            </a>
                        }
                        {messages["TIKTOK_URL"] !== "" &&
                            <a target="_blank" rel="noopener noreferrer" aria-label="TikTok icon" href={messages.TIKTOK_URL}>
                                <svg className="fill-gray-400 hover:fill-white" xmlns="http://www.w3.org/2000/svg"
                                     height="1.5em" viewBox="0 0 448 512">
                                    <path
                                        d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z"/>
                                </svg>
                            </a>
                        }
                        {messages["OF_URL"] !== "" &&
                            <a target="_blank" rel="noopener noreferrer" aria-label="WIKI donations" href={messages.OF_URL}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" height="1.5em">
                                    <rect className="a" width="400" height="400">
                                    </rect>
                                    <path className="fill-gray-400 hover:fill-white"
                                          d="M137.5,75a125,125,0,1,0,125,125A125,125,0,0,0,137.5,75Zm0,162.5A37.5,37.5,0,1,1,175,200,37.45,37.45,0,0,1,137.5,237.5Z">
                                    </path>
                                    <path className="fill-gray-400 hover:fill-white"
                                          d="M278,168.75c31.76,9.14,69.25,0,69.25,0-10.88,47.5-45.38,77.25-95.13,80.87A124.73,124.73,0,0,1,137.5,325L175,205.81C213.55,83.3,233.31,75,324.73,75H387.5C377,121.25,340.81,156.58,278,168.75Z">
                                    </path>
                                </svg>
                            </a>
                        }
                        {messages["WIKI_URL"] !== "" &&
                            <a target="_blank" rel="noopener noreferrer" aria-label="WIKI donations" href={messages.WIKI_URL}>
                                <svg className="fill-gray-400 hover:fill-white" xmlns="http://www.w3.org/2000/svg"
                                     height="1.5em" viewBox="0 0 512 512">
                                    <path
                                        d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
                                </svg>
                            </a>
                        }
                    </div>

                    <div className="flex flex-wrap md:justify-end gap-6 md:gap-4">
                        <a href="/playlists"
                           className="no-underline text-gray-400 hover:text-white">Playlists</a>

                        <a href="/network" className="no-underline text-gray-400 hover:text-white">Network</a>

                        <a href="/terms-of-service" className="no-underline text-gray-400 hover:text-white">Terms of Service</a>

                        <a href="/privacy" className="no-underline text-gray-400 hover:text-white">Privacy Policy</a>

                        <a href="/faq" className="no-underline text-gray-400 hover:text-white">FAQ</a>

                        <a href="/get-in-touch" className="no-underline text-gray-400 hover:text-white">Contact</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
